// extracted by mini-css-extract-plugin
export default {"bookingCard":"BookingCard_bookingCard__9mgjl","bookingInfo":"BookingCard_bookingInfo__u6N-u","viewButton":"BookingCard_viewButton__9o-7D"};